
import { FormResponse } from '../form/form.response';
import { FormTemplate } from '../form/form.template';
import { WorkOrderStatusSystemName } from '../job/workorder.status.system.name';
import { Allocation } from '../scheduler/allocation';
import { Activity } from '../shared/activity';
import { DocumentLibrary } from '../shared/document.library';
import { EmbeddedCode } from '../shared/code';
import { Task } from '../tasks/task';

export type ClaimDownstreamStatusChange = WorkOrderStatusSystemName.Dispatched | WorkOrderStatusSystemName.InProgress | WorkOrderStatusSystemName.OnHold | WorkOrderStatusSystemName.Completed;

export type ClaimDownstreamSyncEvent = 'FirstDispatched' | 'StatusUpdated' | 'ActivityDeleted' | 'ActivityUpdated' | 'AllocationDeleted' | 'AllocationUpdated' | 'ItemUpdated' | 'ItemDeleted' | 'TaskUpdated' | 'TasksRequested' | 'FormSubmitted';
export type ClaimUpstreamSyncEvent = 'StatusUpdated' | 'ItemCreated' | 'ItemDeleted' | 'ItemUpdated' | 'TaskCreated' | 'TaskUpdated' | 'TaskDeleted';

export type ClaimUpstreamSyncTaskPayload = {
    task: Task;
    form?: FormTemplate;
    document?: DocumentLibrary;
}

export type ClaimDownstreamSyncTaskPayload = {
    task: Task;
    form?: FormResponse;
}

export type ClaimDownstreamSyncMessage =
    ({
        event: ClaimDownstreamSyncEvent;
        claimToken: string;
    }) &
    ({
        event: 'StatusUpdated';
        status: ClaimDownstreamStatusChange;
        note: string;
        date: Date;
    } | {
        event: 'ActivityUpdated' | 'ActivityDeleted';
        value: Activity;
    } | {
        event: 'AllocationUpdated' | 'AllocationDeleted';
        value: Allocation;
    } | {
        event: 'ItemUpdated' | 'ItemDeleted';
        value: EmbeddedCode;
    } | {
        event: 'TaskUpdated';
        value: ClaimDownstreamSyncTaskPayload;
    } | {
        event: 'FormSubmitted';
        value: FormResponse;
    } | {
        event: 'TasksRequested';
    });

export type ClaimUpstreamSyncMessage =
    ({
        claimToken: string;
        event: ClaimUpstreamSyncEvent;
    }) & {
        event: 'StatusUpdated';
        claimToken: string;
        value: ClaimDownstreamStatusChange;
    } | {
        event: 'ItemUpdated' | 'ItemDeleted';
        claimToken: string;
        value: EmbeddedCode;
    } | {
        event: 'TaskUpdated';
        claimToken: string;
        value: ClaimUpstreamSyncTaskPayload;
    } | {
        event: 'TasksDeleted';
        claimToken: string;
        value: string[];
    };

const t: ClaimDownstreamSyncMessage = {
    event: 'StatusUpdated',
    claimToken: '123',
    status: WorkOrderStatusSystemName.Dispatched,
    note: 'test',
    date: new Date()
}